import { Tag } from '@servicetitan/design-system';
import { FC } from 'react';
import { EstimateStatus } from '../../../../enums/estimate-status';

const statusesEstimate: Record<EstimateStatus, [string | undefined, string]> = {
    [EstimateStatus.Open]: ['warning', 'Ready to sign'],
    [EstimateStatus.Sold]: ['success', 'Accepted'],
    [EstimateStatus.Dismissed]: ['critical', 'Dismissed'],
    [EstimateStatus.Expired]: ['inactive', 'Expired'],
};

export const StatusEstimate: FC<{ status: EstimateStatus }> = ({ status }) => {
    const data = statusesEstimate[status];

    return data ? (
        <Tag subtle color={data[0]}>
            {data[1]}
        </Tag>
    ) : null;
};
